import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseService} from './base.service';
import {Observable} from 'rxjs';
import {AlertService} from './alert.service';
import {GlobalService} from './global.service';
import {AppUrl} from '../constants/app-url';
import {UploadService} from './upload.service';

@Injectable({
    providedIn: 'root'
})
export class InsightsService extends BaseService {
    constructor(public http: HttpClient,
                public alertService: AlertService,
                public globalService: GlobalService,
                private fileUploadService: UploadService) {
        super(http, alertService, globalService);
    }


    create(data): Observable<any> {
        return this.postRequest(AppUrl.INSIGHTS(), data);
    }

    detail(id): Observable<any> {
        return this.getRequestWithoutErrorMessage(AppUrl.INSIGHTS(id));
    }

    /*detailBYPCBId(id): Observable<any> {
        return this.getRequestWithoutErrorMessage(AppUrl.UNIVERSITY_COURSE_CURRICULUM_BY_PCB_ID(id));
    }*/

    update(id, data): Observable<any> {
        return this.putRequest(AppUrl.INSIGHTS(id), data);
    }

    get(data): Observable<any> {
        return this.getRequest(AppUrl.INSIGHTS(), data);
    }
    delete(id):Observable<any>{
        return this.deleteRequest(AppUrl.INSIGHTS(id));
    }
    updateStatus(id, data): Observable<any> {
        return this.putRequest(AppUrl.INSIGHT_STATUS(id), data);
    }

    addInTop(id, data):Observable<any>{
        return this.putRequest(AppUrl.ADD_TOP_INSIGHTS(id), data);
    }

    updateMain(id, data): Observable<any> {
        return this.putRequest(AppUrl.INSIGHT_MAIN(id), data);
    }

    fileUpload(params, event): Observable<any> {
        return this.fileUploadService.fileUpload(AppUrl.FILE_UPLOAD(), params, event);
    }

    fileUploadAdmin(params, event): Observable<any> {
        return this.fileUploadService.fileUpload(AppUrl.FILE_UPLOAD_ADMIN(), params, event);
    }
}
